import { render } from "./page-about.vue?vue&type=template&id=48152244&scoped=true&lang=html"
import script from "./page-about.vue?vue&type=script&lang=js"
export * from "./page-about.vue?vue&type=script&lang=js"

import "./page-about.vue?vue&type=style&index=0&id=48152244&lang=css&scoped=true"
script.render = render
script.__scopeId = "data-v-48152244"

export default script